import { createReducer, on } from '@ngrx/store';

import {
  memberRewardPickupClearState,
  memberRewardPickupListRequest,
  memberRewardPickupListResponse,
  resetSelectedMemberRewardPickup,
  selectMemberRewardPickup
} from './member-reward-pickup.actions';
import {
  MemberRewardPickupContent,
  MemberRewardPickupCriteria,
  MemberRewardPickupPagination
} from '../../models/member-reward-pickup';

export const memberRewardPickupKey = 'memberRewardPickup';

export interface MemberRewardPickupState {
  isSuccess: boolean;
  memberRewardPickupList: MemberRewardPickupPagination;
  criteriaObject: MemberRewardPickupCriteria;
  memberRewardPickup: MemberRewardPickupContent;
}

export const initialState: MemberRewardPickupState = {
  isSuccess: null,
  memberRewardPickupList: null,
  criteriaObject: null,
  memberRewardPickup: null
};

export const memberRewardPickupReducer = createReducer<MemberRewardPickupState>(
  initialState,
  on(memberRewardPickupClearState, () => {
    return initialState;
  }),
  on(memberRewardPickupListRequest, (state, { payload }) => {
    return { ...state, criteriaObject: payload };
  }),
  on(memberRewardPickupListResponse, (state, { response }) => {
    return { ...state, memberRewardPickupList: response };
  }),
  on(selectMemberRewardPickup, (state, { data }) => {
    return {
      ...state,
      memberRewardPickup: data
    };
  }),
  on(resetSelectedMemberRewardPickup, (state) => {
    return {
      ...state,
      memberRewardPickup: null
    };
  })
);
